import type * as Flows from './types.no-deps'
import { pipe } from '../../lib/functional/pipe.no-deps'
import { find } from '../../lib/functional/generator.no-deps'
import { walkSections } from './generators.no-deps'
import { findElementInSection } from './element.no-deps'

export function findSection(section: Flows.Section, sectionId: Flows.ElementId): Flows.Section {
    return pipe(
        section,
        walkSections(),
        find((s) => s.id === sectionId)
    )
}

export function findSectionWithElement(flow: Flows.Section, elementId: Flows.ElementId): Flows.Section {
    for (const section of walkSections()(flow)) {
        if (findElementInSection(section, elementId) != null) return section
    }
    return null
}
